import { FaqComponent } from '@adminprodigydesign/axis';
import { Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { SERVICES_DATA } from '../../../assets/data/services-data';
import { FaqItem } from '../../../assets/data/faq-data';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

// service.model.ts
export interface Service {
  id: number;
  title: string;
  description: string;
  image: string;
  phone?: string;
  cta?: string;
  tags: string[];
  slug: string;
}

@Component({
  selector: 'app-services',
  imports: [CommonModule, FaqComponent],
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'], // ← plural
})
export class ServicesComponent {
  readonly services: Service[] = SERVICES_DATA;
  faqItem = FaqItem;

  @ViewChildren('svcSection') private sections!: QueryList<ElementRef>;
  constructor(private route: ActivatedRoute) {}

  ngAfterViewInit(): void {
    this.route.fragment.subscribe((frag) => {
      if (!frag) return;
      // match id="boiler-installations" etc.
      const el = this.sections.find((ref) => ref.nativeElement.id === frag)
        ?.nativeElement as HTMLElement | undefined;

      if (el) {
        // slight delay lets the page finish layout
        setTimeout(
          () => el.scrollIntoView({ behavior: 'smooth', block: 'start' }),
          50
        );
      }
    });
  }
}
